import { Link, useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { siteConfig, telHref } from "@/config/siteConfig";
import { trackEvent } from "@/lib/analytics";
import { Logo } from "@/components/Logo";

const LEGAL = [
  { to: "/kvkk", label: "KVKK Aydınlatma Metni", testid: "footer-kvkk-link" },
  { to: "/gizlilik-politikasi", label: "Gizlilik Politikası", testid: "footer-privacy-link" },
  { to: "/cerez-politikasi", label: "Çerez Politikası", testid: "footer-cookie-link" },
];

export const Footer = () => {
  const { pathname } = useLocation();
  const year = new Date().getFullYear();
  const linkHref = (hash) => (pathname === "/" ? `#${hash}` : `/#${hash}`);

  return (
    <footer data-testid="site-footer" className="bg-ink-950 text-white/60">
      <div className="mx-auto max-w-6xl px-5 pb-28 pt-16 md:pb-12">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo dark />
            <p className="mt-5 max-w-xs text-sm leading-relaxed">
              Salihli merkezli 7/24 oto çekici ve oto kurtarma hizmeti. Şehir içi ve şehirlerarası araç taşıma.
            </p>
            <a
              href={telHref}
              data-testid="footer-call-button"
              onClick={() => trackEvent("phone_click", "footer")}
              className="mt-6 inline-flex min-h-[44px] items-center gap-2 rounded-full border border-white/20 px-5 py-2.5 font-display text-sm font-bold text-white transition-[background-color,border-color] duration-200 hover:border-brand hover:bg-brand"
            >
              <Phone className="h-4 w-4" aria-hidden="true" />
              {siteConfig.phone.display}
            </a>
          </div>
          <nav aria-label="Alt menü">
            <h3 className="font-display text-xs font-bold uppercase tracking-[0.24em] text-white/40">Menü</h3>
            <ul className="mt-5 space-y-3">
              {siteConfig.nav.map((item) => (
                <li key={item.hash}>
                  <a
                    href={linkHref(item.hash)}
                    data-testid={`footer-nav-${item.hash}`}
                    className="text-sm font-semibold transition-colors hover:text-white"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <nav aria-label="Yasal bağlantılar">
            <h3 className="font-display text-xs font-bold uppercase tracking-[0.24em] text-white/40">Yasal</h3>
            <ul className="mt-5 space-y-3">
              {LEGAL.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    data-testid={item.testid}
                    className="text-sm font-semibold transition-colors hover:text-white"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
        <div className="mt-14 flex flex-col gap-2 border-t border-white/10 pt-6 text-xs sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {year} {siteConfig.businessName}. Tüm hakları saklıdır.
          </p>
          <p>
            {siteConfig.address.locality} / {siteConfig.address.region} — 7/24 Hizmet
          </p>
        </div>
      </div>
    </footer>
  );
};
